
import { defineComponent, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import RegisterFlow from '@/components/registerTeam/RegisterFlow.vue'
import useValidateForAccess from '@/Hooks/useValidateForAccess'
import AppInfo from '@/util/AppInfo'
import StoreUtil from '@/stores/StoreUtil'

export default defineComponent({
  name: 'CompletePage',

  setup() {
    const { t, locale } = useI18n()
    const isSmartPhone = computed(() => {
      return AppInfo.isSmartPhone
    })
    const appStoreLink = computed(() => {
      if (isSmartPhone.value) {
        return 'https://apps.apple.com/jp/app/fl-ux-for-iphone/id1483204755'
      }
      return 'https://apps.apple.com/jp/app/fl-ux/id1474784636'
    })
    const fluxLoginUrl = computed(() => {
      return `${process.env.VUE_APP_FLUX_LOGIN_PAGE_BASE_URL}/fl/index.html#/login`
    })
    const addLineFriendUrl = computed(() => {
      return `${process.env.VUE_APP_FLUX_ADD_LINE_FRIEND_URL}`
    })

    /**
     * エリア情報を返す(Asia, Europe, America)
     * 取得できない場合は空文字を返す。
     * @returns {string} エリア情報
     */
    const area = computed(() => {
      const url = Object.entries(JSON.parse(process.env.VUE_APP_ALL_API_BASE_URL || {}))
        .map(([key, value]) => ({ key, value }))
        .find(x => x.value === process.env.VUE_APP_API_BASE_URL)
      return url === undefined ? '' : url.key
    })

    /**
     * LINEのリンクを表示するかどうか
     */
    const isLineRegistrationVisible = computed(() => {
      // エリアが取得できない場合は表示する
      return area.value ? area.value === 'Asia' : true
    })

    const enterAccountStore = StoreUtil.useStore('EnterAccountStore')
    /**
     * ログインボタンを表示するかどうか
     */
    const isLoginVisible = computed(() => {
      if (isSmartPhone.value) return false
      if (enterAccountStore.isOfflinePlan) return false
      return true
    })

    /**
     * 操作説明ガイダンス予約ページへのリンク
     */
    const opeExLink = computed(() => {
      return `${process.env.VUE_APP_OPE_EXPLANATION}`
    })

    /**
     * アプリダウンロードリンク
     */
    const appDlLink = computed(() => {
      return area.value === 'Asia'
        ? 'https://fl-ux.run-edge.com/#app-dl'
        : 'https://fl-ux.co/#app-download'
    })

    /**
     * 予約画面へのリンクを表示するかどうか
     */
    const isShowOpeExLink = computed(() => {
      if (enterAccountStore.isInvitedUser) return false
      if (locale.value !== 'ja') return false
      return true
    })

    onMounted(() => {
      let propertyNames = [
        'tokenId',
        'displayName',
        'username',
        'password',
      ] as (keyof typeof enterAccountStore)[]
      if (enterAccountStore.hasAffiliatedOrganizations) {
        // 既に他組織に所属済みユーザの新規組織作成のとき
        propertyNames = ['tokenId', 'displayName']
      } else if (enterAccountStore.isExistingAccount) {
        // 既に他組織に所属済みユーザが他チームに招待されたとき
        propertyNames = ['tokenId', 'accessToken']
      }
      useValidateForAccess('EnterAccountStore', propertyNames, 'ErrorPage')
    })
    return {
      isSmartPhone,
      isShowOpeExLink,
      appStoreLink,
      opeExLink,
      appDlLink,
      fluxLoginUrl,
      addLineFriendUrl,
      isLineRegistrationVisible,
      isLoginVisible,
      t,
      locale,
      enterAccountStore,
    }
  },
  components: {
    RegisterFlow,
  },
})
